import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var SelectIcon = createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M18.94,3.07H5a2,2,0,0,0-2,2v14a2,2,0,0,0,2,2h14a2,2,0,0,0,2-2v-14A2,2,0,0,0,18.94,3.07Zm-3.21,8.22-3.29,3.3a.71.71,0,0,1-1,0l-3.28-3.3a.72.72,0,0,1,.51-1.22h6.57A.72.72,0,0,1,15.73,11.29Z"
}), 'SelectIcon');